import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=3ddd2ce2&scoped=true&"
import script from "./PrintPage.vue?vue&type=script&lang=js&"
export * from "./PrintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd2ce2",
  null
  
)

export default component.exports